import { Component } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-nav-bar',
  imports: [SharedModule , RouterLink],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.css',
})
export class NavBarComponent {}
